<div class="component-viewer">
    <mat-card>
        <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="dataSource" [enableSearch]="false" [showFilterToggle]="false">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="dataSource">
            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let invoice">
                    <div *ngFor="let line of invoice.lines.data">
                        {{ line.description }}
                    </div>
                </td>
            </ng-container>

            <!-- Amount Due Column -->
            <ng-container matColumnDef="amountDue">
                <th mat-header-cell *matHeaderCellDef> Amount Due </th>
                <td mat-cell *matCellDef="let invoice">
                    {{ formatAmount(invoice.amount_due) }}
                </td>
            </ng-container>

            <!-- Amount Paid Column -->
            <ng-container matColumnDef="amountPaid">
                <th mat-header-cell *matHeaderCellDef> Amount Paid </th>
                <td mat-cell *matCellDef="let invoice">
                    {{ formatAmount(invoice.amount_paid) }}
                </td>
            </ng-container>

            <!-- Amount Remaining Column -->
            <ng-container matColumnDef="amountRemaining">
                <th mat-header-cell *matHeaderCellDef> Amount Remaining </th>
                <td mat-cell *matCellDef="let invoice">
                    {{ formatAmount(invoice.amount_remaining) }}
                </td>
            </ng-container>

            <!-- Period Column -->
            <ng-container matColumnDef="period">
                <th mat-header-cell *matHeaderCellDef> Period </th>
                <td mat-cell *matCellDef="let invoice">
                    <div *ngFor="let line of invoice.lines.data">
                        {{ line.period.start * 1000 | date:'mediumDate' }} - {{ line.period.end * 1000 | date:'mediumDate' }}
                    </div>
                </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let invoice" class="text-center">
                    <mat-chip [class]="invoice.status === 'paid' ? 'primary' : 'warning'" [highlighted]="invoice.status === 'paid' ? true : false" selected>
                        {{ invoice.status.capitalizeFirst() }}
                    </mat-chip>
                </td>
            </ng-container>

            <!-- Invoice Column -->
            <ng-container matColumnDef="invoice">
                <th mat-header-cell *matHeaderCellDef> Invoice </th>
                <td mat-cell *matCellDef="let invoice">
                    <a mat-icon-button [href]="invoice.hosted_invoice_url" target="_blank" *ngIf="invoice.hosted_invoice_url">
                        <mat-icon>launch</mat-icon>
                    </a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card>
</div>
